import { types } from '../constants'

const index = {
  pending: `${types.create}_PENDING`,
  fulfilled: `${types.create}_FULFILLED`,
  rejected: `${types.create}_REJECTED`
}

export const create = {
  [index.pending]: ({ draft }) => {
    draft.template.create.loading = true
    draft.template.create.error = null
  },
  [index.fulfilled]: ({ draft, action }) => {
    draft.template.item.data = action.payload
    draft.template.create.loading = false
    draft.template.create.error = null
  },
  [index.rejected]: ({ draft, action }) => {
    draft.template.create.loading = false
    draft.template.create.error = action.payload
  }
}
